module.exports = __webpack_public_path__ + "static/media/raygun.684aa8f3.svg";